import PlansInterceptor from '../PlansInterceptor'

const api = new PlansInterceptor()

export default {
    getDescontosComercial() {
        return api.get(`/descontos/comercial`)
    }
}
